<template>
  <div class="py-88 px-40">
    <h2 class="text-white font-3xl font-bold mb-40">
      More about the concepts in this tutorial:
    </h2>
    <ul class="list-reset font-xl font-semibold mb-56">
      <li class="mb-32 text-jupiter-2">
        <chevrons-right class="h-12 mr-24 fill-current" />
        <a
          target="_blank"
          class="text-jupiter-2 hover:text-white no-underline text-lg transition transition-fast transition-in-out"
          href="https://www.algolia.com/doc/guides/getting-started/what-is-algolia/"
          >What is Algolia?</a
        >
      </li>
      <li class="mb-32 text-jupiter-2">
        <chevrons-right class="h-12 mr-24 fill-current" />
        <a
          target="_blank"
          class="text-jupiter-2 hover:text-white no-underline text-lg transition transition-fast transition-in-out"
          :href="
            `https://www.algolia.com/doc/api-reference/widgets/${$store.getters.getUiLibrary.slug}/`
          "
          >{{ $store.getters.getUiLibrary.name }} Reference Documentation</a
        >
      </li>
      <li class="mb-32 text-jupiter-2">
        <chevrons-right class="h-12 mr-24 fill-current" />
        <a
          target="_blank"
          class="text-jupiter-2 hover:text-white no-underline text-lg transition transition-fast transition-in-out"
          href="https://www.algolia.com/doc/api-reference/"
          >API Reference</a
        >
      </li>
      <li class="text-jupiter-2">
        <chevrons-right class="h-12 mr-24 fill-current" />
        <a
          target="_blank"
          class="text-jupiter-2 hover:text-white no-underline text-lg transition transition-fast transition-in-out"
          href="https://www.algolia.com/doc/guides/"
          >Algolia Concepts</a
        >
      </li>
    </ul>
    <h2 class="text-white font-3xl font-bold mb-40">
      Share what you’ve built:
    </h2>
    <div class="flex">
      <div
        class="flex-grow bg-white px-24 py-8 rounded-sm text-shuttle-grey whitespace-no-wrap truncate"
      >
        {{ getShareableLink }}
      </div>
      <snippet-copy-button
        class="flex-no-shrink w-40 h-40 opacity-80 hover:opacity-100 rounded-full bg-east-bay ml-16"
        :content="getShareableLink"
      />
    </div>
  </div>
</template>

<script>
import Copy from '@/assets/images/copy.svg'
import ChevronsRight from '@/assets/images/chevrons-right.svg'

import SnippetCopyButton from '@/components/SnippetCopyButton'

export default {
  components: { Copy, ChevronsRight, SnippetCopyButton },
  computed: {
    getShareableLink() {
      return `https://codesandbox.io/s${this.$store.getters.getCodeSandboxUrl}`
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$store.commit('setStepAsCompleted', { step: 4 })
    })
  }
}
</script>
